// Return a list of objects that are only contained in the left one
export function getOnlyInLeft(
  left: any[],
  right: any[],
  predicate: (a: any, b: any) => boolean
) {
  return left.filter(
    (leftValue) => !right.some((rightValue) => predicate(leftValue, rightValue))
  );
}

// Given a two shape lists, find the differences between them if any
export function getDiff(
  a: any[],
  b: any[],
  predicate: (a: any, b: any) => boolean
): any[] {
  return [...getOnlyInLeft(a, b, predicate), ...getOnlyInLeft(b, a, predicate)];
}

// Limit the calling of a function to only happen after its been idle for a certain time
export function debounce(func: Function, timeout = 300) {
  let timer: number;
  return (...args: any[]) => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      func.apply(null, args);
    }, timeout);
  };
}

// Convert a blob object (image) to a base64 string
export function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result?.toString() ?? "");
    reader.readAsDataURL(blob);
  });
}
